import type { IconName } from '@customerio/pluma-icons';
import { resolveProductTaxonomyTerm, type ProductTaxonomyTermReference } from '@/services/product-taxonomy';

export type MessagingUseCaseOption = {
  value: string;
  label: string;
  /**
   * Rendered one line each. An empty line becomes a non-breaking space so every
   * card's description occupies the same two lines.
   */
  descriptionLines: string[];
  icon: IconName;
};

/**
 * The funnel runs pre-auth, so there is no account to read the taxonomy rename
 * flags from and the terms always resolve at the `current` stage. Pinning the
 * stage keeps this off the account-gated `useProductTaxonomy` hook.
 */
function term(reference: ProductTaxonomyTermReference): string {
  return resolveProductTaxonomyTerm(reference, 'current');
}

export const MESSAGING_USE_CASES: MessagingUseCaseOption[] = [
  {
    value: 'transactional',
    label: 'Transactional messages',
    descriptionLines: ['Receipts, confirmations,', 'password reset'],
    icon: 'transactional-api',
  },
  {
    value: 'automated_workflows',
    label: 'Automated workflows',
    descriptionLines: [`Trigger-based ${term('campaigns.plural')}`, ''],
    icon: 'campaigns',
  },
  {
    value: 'newsletters',
    label: term('broadcasts.titlePlural'),
    descriptionLines: ['Updates across email, push, or', 'in-app'],
    icon: 'broadcast',
  },
  {
    value: 'dynamic_segmentation',
    label: 'Dynamic segmentation',
    descriptionLines: ['Behavior-based segmentation', ''],
    icon: 'segment',
  },
];
